import { GET_CLOSE, SET_CLOSE } from "../constants/hotspot-close-constants";

export const getHotspotClose = () => ({
  type: GET_CLOSE,
});

export const setHotspotClose = (status) => ({
  type: SET_CLOSE,
  status,
});
